import { render, staticRenderFns } from "./accountInoutDtl.vue?vue&type=template&id=04fac006&scoped=true&"
import script from "./accountInoutDtl.vue?vue&type=script&lang=js&"
export * from "./accountInoutDtl.vue?vue&type=script&lang=js&"
import style0 from "./accountInoutDtl.vue?vue&type=style&index=0&id=04fac006&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fac006",
  null
  
)

export default component.exports